import { motion } from "framer-motion";

const INITIAL = { opacity: 0, y: 24 };
const IN_VIEW = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-60px" };

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={INITIAL}
    whileInView={IN_VIEW}
    viewport={VIEWPORT}
    transition={{ duration: 0.6, delay, ease: "easeOut" }}
    className={className}
  >
    {children}
  </motion.div>
);
